export const pageToSkip = (page: number, limit: number = 10) => {
  return (page - 1) * limit;
};

export const skipToPage = (skip:number,limit:number=10)=>{
  return (skip/limit)+1
}